import React, { ReactElement, useEffect, useState } from 'react'
import { ContainerFormulario } from '@pages/style'
import { Row, Col, Typography, message, Button, Spin } from 'antd'
import { HeaderPage, Input } from '@components/atoms'
import { useRouter } from '@customHooks'
import { useForm } from 'react-hook-form'
import api from '@services/api'
import { SaveOutlined } from '@ant-design/icons'

export default function FormularioPrograma(): ReactElement {
  const {
    navigate,
    state,
    params: { id },
  } = useRouter<'id'>()
  const { control, reset, handleSubmit } = useForm()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (id && state) {
      reset({ ...(state as object) })
    }
  }, [state, id])

  const onSubmit = () => {
    handleSubmit(async (values) => {
      setLoading(true)
      id
        ? await api
            .put(`/programas/${id}`, values)
            .then(() => {
              setLoading(false)
              message.success('Programa atualizado com sucesso!')
              navigate('/manutencao/seguranca/programas')
            })
            .catch(() => setLoading(false))
        : await api
            .post('/programas', values)
            .then(() => {
              setLoading(false)
              message.success('Programa cadastrado com sucesso!')
              navigate('/manutencao/seguranca/programas')
            })
            .catch(() => setLoading(false))
    })()
  }

  return (
    <ContainerFormulario>
      <HeaderPage
        title={id ? 'Atualizar Programa' : 'Novo Programa'}
        onBack={() => navigate(-1)}
        extra={[
          <Button
            key='salvar'
            icon={<SaveOutlined />}
            type='primary'
            size='large'
            loading={loading}
            onClick={onSubmit}
          >
            Salvar
          </Button>,
        ]}
      />
      <form>
        <Spin spinning={loading}>
          <Row gutter={[12, 12]} align='bottom'>
            <Col span={4}>
              <Typography.Title level={5}>Programa</Typography.Title>
              <Input
                control={control}
                name='NOMEUSUARIO'
                rules={{ required: 'Campo obrigatório' }}
              />
            </Col>
            <Col span={20}>
              <Typography.Title level={5}>Descrição</Typography.Title>
              <Input
                control={control}
                name='DESCUSUARIO'
                rules={{ required: 'Campo obrigatório' }}
              />
            </Col>
          </Row>
        </Spin>
      </form>
    </ContainerFormulario>
  )
}
